import React from 'react';
import { AdminSettings, PartitionToggle } from 'components';

export const cheAdminSettingsPage = () => {
    return (
        <>
            <PartitionToggle />
            <br />
            <AdminSettings />
        </>
    );
};
